import { UserBehaviorRisksAppController } from '../controller/UserBehaviorRisksAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class UserBehaviorRisksAppWebComponent extends BaseWebComponentElement {
  private _externalFilters: Array<any> = [];
  private _openSideMenuForFirstItem = false;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: UserBehaviorRisksAppController,
    });
  }

  set externalFilters(filters: Array<any>) {
    this._externalFilters = filters;
  }

  get externalFilters() {
    return this._externalFilters;
  }

  set openSideMenuForFirstItem(value: boolean) {
    this._openSideMenuForFirstItem = value;
  }

  get openSideMenuForFirstItem() {
    return this._openSideMenuForFirstItem;
  }

  setPageNumber(page: number) {
    if (this.controller) {
      this.controller.view.dom.$grid.pageNumber = page || 1;
    }
  }
}
